<template>
  <div>
    <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-overlay :value="!locationStatus">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <center>
      <v-img height="100%" :src="imageUrl"></v-img>
      <v-container fluid>
        <v-row dense>
          <!-- <v-col cols="12"> </v-col>
          <v-col cols="12">
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col> -->
          <v-alert
            v-if="checkHoliday"
            border="top"
            colored-border
            type="warning"
            elevation="2"
          >
            วันนี้เป็นวันหยุดของท่าน ด้วยรักและห่วงใย พักผ่อน
            และรักษาสุขภาพแล้วเราค่อยมาเริ่มงานกันใหม่ในวันทำงานกันนะคะ
          </v-alert>
          <v-alert
            v-if="shiftItem.leave"
            border="top"
            colored-border
            type="warning"
            elevation="2"
          >
            วันนี้เป็นวัน {{shiftItem.leave}} ({{shiftItem.leaveSummaryDayName}}) ของท่าน ด้วยรักและห่วงใย หากจำเป็นเข้าพื้นที่ สวมหน้ากากอนามัน ลดเสี่ยง ปลอดภัยจากโควิด
          </v-alert>
          <!-- <template v-if="checkTimeAfterCheckIN">
            <v-progress-circular
              :width="3"
              color="green"
              indeterminate
            ></v-progress-circular>
          </template> -->
          <template v-if="!shiftItem.leave ||  shiftItem.leaveSummaryDay < 1">
            <template v-if="!checkTimeAfterCheckIN">
              <v-row>
              <v-col cols="12" v-if="!dataReady">
                <h6>ระบบลงเวลาเข้า - ออกงาน</h6>
                <h3>{{ profile.empFull_NameTH }}</h3>
                <v-container v-if="!shiftItem.checkInStartStamp">
                  <v-row>
                    <v-col cols="12" class="py-2" >
                      <v-divider></v-divider>
                      วันนี้คุณทำงานที่ไหน
                      <br>
                      <v-btn-toggle
                        v-model="location"
                        tile
                        color="deep-purple accent-3"
                        group
                      >
                        <v-btn value="Office">
                          Office
                          <v-icon right> mdi-city </v-icon>
                        </v-btn>

                        <v-btn value="WFH">
                          WFH
                          <v-icon right> mdi-home </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="outsild"
                        tile
                        color="orange accent-4"
                        group
                      >
                        <v-btn value="OutSite">
                          OutSite
                          <v-icon right> mdi-run-fast </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <template v-if="outsild == 'OutSite'">
                      <v-btn-toggle
                        v-model="location"
                        tile
                        color="deep-purple accent-3"
                        group
                      >
                        <v-btn value="Booth">
                          Booth
                          <v-icon right> mdi-home-map-marker </v-icon>
                        </v-btn>

                        <v-btn value="Outing">
                          Outing
                          <v-icon right> mdi-walk </v-icon>
                        </v-btn>

                        <v-btn value="training">
                          Train
                          <v-icon right> mdi-file-excel </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="location"
                        tile
                        color="deep-purple accent-3"
                        group
                      >
                        <v-btn value="Other">
                          Other
                          <v-icon right> mdi-comment-question </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-model="otherBranch"
                        tile
                        color="orange accent-4"
                        group
                      >
                        <v-btn value="Branch">
                          เดินทางไปต่างสาขา
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-if="otherBranch === 'Branch'"
                        v-model="location"
                        tile
                        color="deep-purple accent-3"
                        group
                      >
                        <v-btn value="BC-CW">
                          CW
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>

                        <v-btn value="BC-PKM">
                          PKM
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>

                        <v-btn value="BC-NK">
                          NK
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn-toggle
                        v-if="otherBranch === 'Branch'"
                        v-model="location"
                        tile
                        color="deep-purple accent-3"
                        group
                      >
                        <v-btn value="BC-BKN">
                          BKN
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>

                        <v-btn value="BC-HO">
                          HO
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>

                        <v-btn value="BC-HD">
                          HD
                          <v-icon right> mdi-office-building </v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      </template>
                      <v-divider></v-divider>
                    </v-col>
                    <v-divider></v-divider>
                     <v-col cols="12" v-if="location">
                       <v-textarea
                          maxlength="100"
                          rows="3"
                          row-height="25"
                          outlined
                          v-model="remark"
                          clearable
                          clear-icon="mdi-close-circle"
                          label="หมายเหตุ"
                          :rules="nameRules"
                        ></v-textarea>
                     </v-col>
                    <v-col cols="12" v-if="location">
                      <v-btn
                        x-large
                        color="green"
                        dark
                        @click="checkIn()"
                        v-if="hideButtonCheck && !shiftItem.checkInStartStamp && locationStatus && !dataReady"
                      >
                      <v-icon dark> mdi-alarm-check </v-icon>
                        ลงเวลาเข้างาน
                      </v-btn>
                      <v-btn disabled x-large v-if="shiftItem.checkInStartStamp">
                        {{ shiftItem.checkInStartStamp }}
                      </v-btn>
                    </v-col>

                    <v-card-text>
                      <div>*ระบบเปิดให้ลงเวลาเข้างาน</div>
                      <div class="text--primary">
                        <small>
                          ตั้งแต่ช่วงเวลา
                          {{ shiftItem.masShiftTypeBeforeStart }} น. -
                          {{ shiftItem.masShiftTypeStartTime }} น.
                        </small>
                      </div>
                    </v-card-text>
                  </v-row>
                </v-container>
                <br>
                <br>
                <!-- <v-container > -->
                <v-row v-if="shiftItem.checkInStartStamp">
                  <!-- <v-row  v-if="shiftItem.checkInStartStamp"> -->
                  <v-col cols="12">
                    <v-btn
                        x-large
                        color="purple"
                        dark
                      @click="checkOut()"
                      v-if="hideButtonCheck && !shiftItem.checkInEndStamp && locationStatus"
                      >
                      <v-icon dark> mdi-alarm-check </v-icon>
                        ลงเวลาออกงาน
                      </v-btn>
                    <v-btn disabled large v-if="shiftItem.checkInEndStamp">
                      <!-- {{ shiftItem.checkInEndStamp }} -->
                      ลงเวลาออกงานเรียบร้อย
                    </v-btn>
                    <v-card-text>
                      <div>*ระบบเปิดให้ลงเวลาเลิกงาน</div>
                      <div class="text--primary">
                        <small>
                          ตั้งแต่ช่วงเวลา {{ shiftItem.masShiftTypeEndTime }} น. -
                          {{ shiftItem.masShiftTypeAfterEnd }} น.
                        </small>
                      </div>
                    </v-card-text>
                  </v-col>
                </v-row>
                <!-- </v-container> -->
                <!-- </v-card> -->
              </v-col>
              </v-row>

            </template>
          </template>
          <!-- <v-col>
          <GmapMap
            :center="center"
            :zoom="19"
            style="width: 100%; height: 400px"
          >
            <GmapMarker :position="center" />
          </GmapMap>
        </v-col> -->
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
import axios from 'axios'
import moment from 'moment' // แปลง date
export default {
  components: {
    gmapApi
  },
  name: 'Info',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liff_checkinout }, function (data) {})
  },
  created () {
    setInterval(this.getNow, 1000)
  },
  data () {
    return {
      //   session: this.$session.getAll(),
      //   sheet: false,
      center: {},
      date: '',
      profile: [],
      shiftItem: [],
      checkItem: [],
      placeId: '',
      geocoder: null,
      dialog_checkin_success: false,
      dialog_checkout_success: false,
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      dataReady: true,
      disableBtnCheckIn: true,
      disableBtnCheckOut: true,
      AccessKey: '',
      ApplicationKey: '',
      checkTimeAfterCheckIN: true,
      checkHoliday: false,
      imageNormalLate: '',
      textNormalLate: 'ท่านได้ลงเวลาเข้างานสำเร็จ',
      imageNormal: '',
      imageUrl: '',
      caption: '',
      imageUrlCheckin: '',
      imageUrlCheckout: '',
      location: '',
      outsild: '',
      otherBranch: '',
      remark: '-',
      locationStatus: true,
      hideButtonCheck: true,
      nameRules: [(v) => !!v || 'กรุณากรอก หมายเหตุ']
    }
  },
  async mounted () {
    // console.log('ENV', process.env)

    localStorage.removeItem('caption')
    localStorage.removeItem('liff_profile_check_in')
    localStorage.removeItem('textNormalLate')
    this.dataReady = true
    // Get Location
    await this.geolocate()
    this.imageUrl = require('@/assets/Icon/Check-in.png')
    this.imageUrlCheckout = require('@/assets/Icon/GroupCheckout.jpg')
    this.imageUrlCheckin = require('@/assets/Icon/GroupCheckin.jpg')
    this.imageNormalLate = require('@/assets/Icon/Normal.jpg')
    this.imageNormal = require('@/assets/Icon/Normal.jpg')
    // this.imageLate = require('@/assets/Icon/late.jpg')

    // Get Line Profile
    // this.getDatCaption()
    await this.checkLiffLogin()
  },
  methods: {
    // Check ENV
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      // alert('getProfile')
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          _this.form.userLinepictureUrl = profileLine.pictureUrl
          _this.getDatCaption()
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      // alert('getProfile_dev')
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
      _this.getDatCaption()
      await _this.getDataEmp(_this.form)
    },
    async geolocate () {
      await navigator.geolocation.getCurrentPosition(
        async (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (center) {
            this.center = center
            this.dataReady = false
            this.locationStatus = true
          }
        },
        (error) => {
          this.dataReady = false
          this.center.lat = null
          this.center.lng = null
          this.locationStatus = true
          console.log('error map :', error.message)
        }
      )
      this.locationStatus = true
      // console.log('locatio', this.center)
    },
    // Getting Employee Info
    async getDataEmp (dt) {
      this.dataReady = true
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          this.dataReady = false
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            await this.getDataShift(response.data[0])
            localStorage.setItem(
              'liff_profile_check_in',
              JSON.stringify(response.data[0])
            )
          } else {
            this.$router.push('/Liff/Login')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // ไม่พบรหัสพนักงาน
          this.dataReady = false
          this.$router.push('/Liff/Login')
        })
    },
    async getDatCaption () {
      this.dataReady = true
      // this.dataMasterShiftItem = []
      var x = Math.floor(Math.random() * 255 + 1)
      var id = x
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/report_covid/getCaption?captionId=" + id,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = false
          // console.log(response.data.captionName)
          this.caption = response.data
          localStorage.setItem('caption', response.data.captionName)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    getNow () {
      const today = new Date()
      const time =
        today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      this.date = time
    },

    // Getting Shift By Emp Code
    async getDataShift (data) {
      this.dataReady = true
      const today = new Date()
      const time = today.getHours() + ':' + today.getMinutes()
      this.shiftItem = []

      var shift = await axios.get(this.DNS_IP + '/shift_import/getByEmpCode?empCode=' + data.empCode)
      if (shift.data) {
        this.dataReady = false
        this.shiftItem = shift.data
        if (this.shiftItem.shiftCode === 'H') {
          this.checkHoliday = true
        }

        // ยังไม่ถึงเวลา
        this.checkTimeAfterCheckIN = true

        if (time >= this.shiftItem.masShiftTypeBeforeStart) {
          this.checkTimeAfterCheckIN = false
          if (this.shiftItem.checkInStartStamp) {
            this.disableBtnCheckIn = false
          } else {
            this.disableBtnCheckIn = true
          }
        } else {
          // ยังไม่ถึงกะเช้า
          this.checkTimeAfterCheckIN = false
          this.disableBtnCheckIn = true
        }
      } else {
        this.dataReady = false
        this.$swal(
          'ไม่มีข้อมูล',
          'วันนี้ท่านไม่มีข้อมูลกะ การทำงาน',
          'error'
        ).then(async (result) => {
          this.$liff.closeWindow()
        })
      }
    },
    async checkIn () {
      this.hideButtonCheck = false
      this.dataReady = true
      //  Get Location
      // this.shiftItem.masShiftTypeBeforeStart = '20:00'
      const currentDateTIme = moment(moment().format('YYYY-MM-DD HH:ss'), 'YYYY-mm-dd HH:ss')
      const masShiftTypeBeforeStart = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeBeforeStart, 'YYYY-mm-dd HH:ss')

      if (currentDateTIme.diff(masShiftTypeBeforeStart) > 0) {
        let location = await this.findLocation(this.location, this.profile.masBranchLat, this.profile.masBranchLng)
        let ds = {
          empCode: this.profile.empCode,
          masShiftTypeCode: this.shiftItem.shiftCode,
          checkInStartLat: this.center.lat,
          checkInStartLong: this.center.lng,
          masBranchLat: location.lat,
          masBranchLng: location.lng,
          location: location.location,
          startDate: this.shiftItem.masShiftTypeStartTime,
          leave: this.shiftItem.leave,
          masShiftBreakEnd: this.shiftItem.masShiftBreakEnd,
          leaveSummaryDayName: this.shiftItem.leaveSummaryDayName,
          remark: this.remark,
          checkInMapUrl: (this.center.lat) ? `https://www.google.co.th/maps/search/${this.center.lat},${this.center.lng}/@${this.center.lat},${this.center.lng},17z` : null //
        }
        console.log(ds)
        await this.addData(ds)
      } else {
        this.dataReady = false
        alert('สามารถเริ่มเข้าได้ตั้งแต่เวลา ' + masShiftTypeBeforeStart.format('HH:ss'))
      }
    },
    async findLocation (location, lat, lng) {
      let result = location.includes('BC')
      let locationLatLng = {}
      if (result) {
        let branchName = await this.setupNameBranch(location)
        let latlng = await this.getDataBranchLatLng(branchName)
        locationLatLng = {
          location: location,
          lat: latlng.masBranchLat,
          lng: latlng.masBranchLng
        }
      } else {
        locationLatLng = {
          location: location,
          lat: lat,
          lng: lng
        }
      }
      return locationLatLng
    },
    async setupNameBranch (location) {
      let branch = '-'
      switch (location) {
        case 'BC-CW':
          branch = 'สาขาแจ้งวัฒนะ'
          break
        case 'BC-PKM':
          branch = 'สาขาปากเกร็ด - เมืองทอง'
          break
        case 'BC-NK':
          branch = 'สาขาหนองแขม'
          break
        case 'BC-BKN':
          branch = 'สาขาบางกอกน้อย'
          break
        case 'BC-HO':
          branch = 'สำนักงานใหญ่'
          break
        case 'BC-HD':
          branch = 'House Development'
          break

        default:
          break
      }
      return branch
    },
    async getDataBranchLatLng (location) {
      let result = await axios.get(this.DNS_IP + '/master_branch/getLatLng?masBranchName=' + location)
      return result.data
    },
    async addData (ds) {
      await axios
        .post(
          this.DNS_IP + '/ch_checkin/add',
          ds
        )
      await this.getDataShiftAfterCheckIN(ds, 'IN')
    },
    async checkOut () {
      this.hideButtonCheck = false
      this.dataReady = true
      var checkInEndStamp = moment(moment().format('YYYY-MM-DD HH:mm'))
      var masShiftTypeEndTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeEndTime)
      var masShiftTypeEndAfterTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeAfterEnd)
      if (this.shiftItem.leaveSummaryDayName && this.shiftItem.leaveSummaryDayName === 'ครึ่งวันบ่าย') {
        masShiftTypeEndTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftBreakStart)
      }
      var durationCheckOut = checkInEndStamp.diff(masShiftTypeEndTime)
      var durationAfterCheckOut = masShiftTypeEndAfterTime.diff(checkInEndStamp)
      let location = await this.findLocation(this.shiftItem.location, this.profile.masBranchLat, this.profile.masBranchLng)
      let ds = {
        empCode: this.profile.empCode,
        masShiftTypeCode: this.shiftItem.shiftCode,
        checkInEndLat: this.center.lat,
        checkInEndLong: this.center.lng,
        masBranchLat: location.lat,
        masBranchLng: location.lng,
        // masBranchLat: this.profile.masBranchLat,
        // masBranchLng: this.profile.masBranchLng,
        endDate: this.shiftItem.masShiftTypeEndTime,
        masShiftBreakStart: this.shiftItem.masShiftBreakStart,
        leaveSummaryDayName: this.shiftItem.leaveSummaryDayName,
        checkOutMapUrl: (this.center.lat) ? `https://www.google.co.th/maps/search/${this.center.lat},${this.center.lng}/@${this.center.lat},${this.center.lng},17z` : null//
      }

      console.log('ds', ds)

      if (this.shiftItem.shiftCode !== 'H') {
        console.log('durationCheckOut', durationCheckOut)
        if (durationCheckOut >= 0) {
          console.log('durationAfterCheckOut', durationAfterCheckOut)
          if (durationAfterCheckOut > 0) {
            await this.updateData(ds)
          } else {
            this.$swal({
              text: 'ท่านไม่สามารถ ลงเวลาออกงาน หลังเวลา ' + this.shiftItem.masShiftTypeAfterEnd,
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: 'ปิด'
            })
              .then(async (result) => {
                this.dataReady = false
                this.$liff.closeWindow()
              })
              .catch((error) => {
                console.log(error)
                this.dataReady = false
                this.$liff.closeWindow()
              })
          }
        } else {
          this.$swal({
            title: 'ท่านลงเวลาออกงาน ก่อน กะการทำงานของท่าน จะดำเนินการต่อหรือไม่ ?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ใช่',
            cancelButtonText: 'ไม่'
          })
            .then(async (result) => {
              await this.updateData(ds)
            })
            .catch((error) => {
              console.log(error)
              this.dataReady = false
            })
        }
      } else {
        await this.updateData(ds)
      }
    },
    async updateData (ds) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ch_checkin/getToDay?empCode=' +
            ds.empCode
        )
        .then(async (response) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/ch_checkin/edit/" + response.data.checkInId,
              ds
            )
            .then(async (response) => {
              this.dataReady = true
              this.textNormalLate = 'ท่านได้ลงเวลาออกงาน สำเร็จ'
              await this.getDataShiftAfterCheckIN(ds, 'OUT')
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function updateData : ', error)
              this.dataReady = true
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    close () {
      this.dialog_checkin_success = false
      this.dialog_checkout_success = false
      this.$liff.closeWindow()
    },
    async getDataShiftAfterCheckIN (data, statusCheckINOUT) {
      // const today = new Date()
      // this.shiftItem = []

      var shift = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getByEmpCode?empCode=' +
            data.empCode
        )
      if (shift['data']) {
        var shiftItem = shift['data']
        this.dataReady = false
        localStorage.setItem('check_shiftItem', JSON.stringify(shiftItem))
        localStorage.setItem('textNormalLate', shiftItem.lateStatus)
        if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
          if (statusCheckINOUT === 'IN') {
            await this.sendingLiffToLine(shiftItem)
          } else {
            await this.sendingLiffToLineOut(shiftItem)
          }
        }
        await this.$router.push('/Liff/CheckinSuccess?checkStatus=' + statusCheckINOUT)
      }
    },
    async sendingLiffToLine (ds) {
      if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
        var image =
        'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCheckInOut%2FNormal.jpg?alt=media'
        if (ds.lateStatus === 'สาย') {
          image =
          'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCheckInOut%2Flate.jpg?alt=media'
        }

        await this.$liff
          .sendMessages([ {
            'type': 'text',
            'text': 'ท่านได้ลงเวลาเข้างานสำเร็จ\nรหัส : ' + ds.empCode + '\nชื่อ : ' + ds.empFull_NameTH + ' \nสาขา : ' + ds.masBranchName + '\nแผนก : ' + ds.masDepartmentName + '\nกะทำงาน :  ' + ds.masShiftTypeName + '\nเวลาเข้างาน : ' + ds.checkInStartStamp + ' น.\nวันที่ : ' + ds.shiftDate + '\n\n' + this.caption.captionName
          },
          {
            type: 'flex',
            altText: 'ท่านได้ลงเวลาเข้า',
            contents: {
              type: 'bubble',
              body: {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: image,
                    size: '100%',
                    gravity: 'center'
                  }
                ],
                paddingAll: '0px'
              },
              footer: {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'box',
                    layout: 'vertical',
                    contents: [
                      {
                        type: 'text',
                        text: 'เวลา ' + ds.checkInStartStamp + ' น.',
                        wrap: true,
                        align: 'center',
                        size: '25px'
                      }
                    ],
                    margin: '10px'
                  },
                  {
                    type: 'box',
                    layout: 'vertical',
                    contents: [
                      {
                        type: 'text',
                        text: this.textNormalLate,
                        wrap: true,
                        align: 'center'
                      },
                      {
                        type: 'text',
                        text:
                          'กะของท่านวันนี้ ' +
                          ds.masShiftTypeName +
                          ' น',
                        wrap: true,
                        align: 'center'
                      }
                    ],
                    margin: '10px'
                  },
                  {
                    type: 'box',
                    layout: 'vertical',
                    contents: [
                      {
                        type: 'text',
                        text: '"' + this.caption.captionName + '"',
                        wrap: true,
                        align: 'center',
                        style: 'italic'
                      }
                    ],
                    margin: '12px'
                  },
                  {
                    type: 'button',
                    action: {
                      type: 'uri',
                      label: 'ประเมินความเสี่ยง',
                      uri: 'line://app/1654154168-6Jl04b87?token=1'
                    },
                    adjustMode: 'shrink-to-fit',
                    style: 'primary',
                    margin: '10px'
                  },
                  {
                    type: 'button',
                    action: {
                      type: 'uri',
                      label: 'ตรวจสอบประวัติ',
                      uri: 'line://app/1654154168-JML0KbN5?page=CheckinHistory'
                    },
                    adjustMode: 'shrink-to-fit',
                    style: 'secondary',
                    margin: '10px'
                  }
                ]
              }
            }
          }
          ])
          .then(function () {
            console.log('send success')
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    async sendingLiffToLineOut (ds) {
      console.log('ท่านได้ลงเวลาออกงานสำเร็จ\nรหัส : ' + ds.empCode + '\nชื่อ : ' + ds.empFull_NameTH + ' \nสาขา : ' + ds.masBranchName + '\nแผนก : ' + ds.masDepartmentName + '\nกะทำงาน :  ' + ds.masShiftTypeName + '\nเวลาเข้างาน : ' + ds.checkInEndStamp + ' น.\nวันที่ : ' + ds.shiftDate + '\n\' ' + this.caption.captionName)
      console.log('sendingLiffToLineOut', ds)
      console.log('checkInEndStamp', ds.checkInEndStamp)
      console.log('textNormalLate', this.textNormalLate)
      console.log('masShiftTypeName', ds.masShiftTypeName)
      if (this.$liff.getContext().type !== 'none' && this.$liff.getContext().type !== 'external') {
        var image =
        'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCheckInOut%2FNormal.jpg?alt=media'
        // if (this.textNormalLate === 'ท่านได้ลงเวลาเข้างาน สาย') {
        //   image =
        //     'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/HRM%2FCheckInOut%2Flate.jpg?alt=media'
        // }

        await this.$liff
          .sendMessages([
            {
              'type': 'text',
              'text': 'ท่านได้ลงเวลาออกงานสำเร็จ\nรหัส : ' + ds.empCode + '\nชื่อ : ' + ds.empFull_NameTH + ' \nสาขา : ' + ds.masBranchName + '\nแผนก : ' + ds.masDepartmentName + '\nกะทำงาน :  ' + ds.masShiftTypeName + '\nเวลาออกงาน : ' + ds.checkInEndStamp + ' น.\nวันที่ : ' + ds.shiftDate + '\n\' ' + this.caption.captionName
            },
            {
              type: 'flex',
              altText: 'ท่านได้ลงออกงานสำเร็จ',
              contents: {
                type: 'bubble',
                body: {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'image',
                      url: image,
                      size: '100%',
                      gravity: 'center'
                    }
                  ],
                  paddingAll: '0px'
                },
                footer: {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          text: 'เวลา ' + ds.checkInEndStamp + ' น.',
                          wrap: true,
                          align: 'center',
                          size: '25px'
                        }
                      ],
                      margin: '10px'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          text: this.textNormalLate,
                          wrap: true,
                          align: 'center'
                        },
                        {
                          type: 'text',
                          text:
                          'กะของท่านวันนี้ ' +
                          ds.masShiftTypeName +
                          ' น',
                          wrap: true,
                          align: 'center'
                        }
                      ],
                      margin: '10px'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          text: '"' + this.caption.captionName + '"',
                          wrap: true,
                          align: 'center',
                          style: 'italic'
                        }
                      ],
                      margin: '12px'
                    },
                    {
                      type: 'button',
                      action: {
                        type: 'uri',
                        label: 'ตรวจสอบประวัติ',
                        uri: 'line://app/1654154168-JML0KbN5?page=CheckinHistory'
                      },
                      adjustMode: 'shrink-to-fit',
                      style: 'secondary',
                      margin: '10px'
                    }
                  ]
                }
              }
            }
          ])
          .then(function () {
            console.log('send success')
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/Checkin.vue